import PropTypes from 'prop-types';
import RequiredInput from '../elements/required-input';

const FirstNameInput = ({
  model = '.first_name', label = 'First name', readOnly = false, controlId = 'firstName', errorLabel = 'user_first_name'
}) => (
  <RequiredInput
    controlId={controlId}
    errorLabel={errorLabel}
    label={label}
    model={model}
    placeholder="First name"
    readOnly={readOnly}
  />
);

FirstNameInput.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  controlId: PropTypes.string,
  errorLabel: PropTypes.string,
};

export default FirstNameInput;
